import * as React from "react";
import Sticky from "react-sticky-el";
import "./MobileStickyHeader.css";

export interface MobileStickyHeaderProps {
    title: string;
    close: () => void;
}

export class MobileStickyHeader extends React.Component<MobileStickyHeaderProps> {
    render() {
        return (
            <div className="General-Util-Css__hide-on-large-screen">
                <Sticky
                        hideOnBoundaryHit={false}
                        stickyClassName={"MobileStickyHeader__mobileSticky"}
                        boundaryElement={".MobileStickyHeader__mobileStickyBoundary"}
                >
                    <div className="MobileStickyHeader__mobileStickyBasics">
                            <h3>{this.props.title}</h3>
                            <div className="MobileStickyHeader__closeButton" onClick={this.props.close} />
                    </div>
                </Sticky>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/MobileStickyHeader.tsx